import React from "react";
import { SportsMatches, SportsTicker } from "../helper/interfaces";
import Image from 'next/image';
import Link from 'next/link'
import { MatchState } from "../helper/enums";

function renderMatch(match: any) {
  return (<div className="kick__v100-gameCell kick__v100-gameCell--small">
  <div className="kick__v100-gameCell__team">
    <div className="kick__v100-gameCell__team__name">{match.homeTeam.name}</div>
    <div className="kick__v100-gameCell__team__shortname">{match.homeTeam.name}</div>
    <div className="kick__v100-gameCell__team__info"></div>
    <div className="kick__v100-gameCell__team__logo">
      {match.homeTeam.icon && (
        <Image src={match.homeTeam.icon} alt="Logo" width="36" height="36" className="kick__flag-shadow" />
      )}
    </div>
  </div>
  <div className="kick__v100-scoreBoard kick__v100-scoreBoard--big-wider">
    {match.score.score && (
      <div>
        {match.score.score.indexOf(":") > 0 && (
          <div className={`kick__v100-scoreBoard__scoreHolder ${match.score.state == MatchState.Live ? 'scoreHolder_live' : ''}`}>
            <div className="kick__v100-scoreBoard__scoreHolder__score">{match.score.score.split(":")[0]}</div>
            <div className="kick__v100-scoreBoard__scoreHolder__divider">:</div>
            <div className="kick__v100-scoreBoard__scoreHolder__score">{match.score.score.split(":")[1]}</div>
          </div>
        )}
      </div>
    )}
    {match.matchDate && (
      <div className="kick__v100-scoreBoard__scoreHolder kick__matchDate">
        <div className="">{match.matchDate}</div>
      </div>
    )} 
    {match.score.subline && (
      <div className="kick__v100-scoreBoard__scoreHolder kick__v100-scoreBoard__scoreHolder--subscore">
        <div className="kick__v100-scoreBoard__scoreHolder__score">{match.score.subline}</div>
      </div>
    )}
    {match.score.halfTimeScore && !match.score.subline && (
      <div className="kick__v100-scoreBoard__scoreHolder kick__v100-scoreBoard__scoreHolder--subscore">
        <div className="kick__v100-scoreBoard__scoreHolder__score">{match.score.halfTimeScore.split(":")[0]}</div>
        <div className="kick__v100-scoreBoard__scoreHolder__divider">:</div>
        <div className="kick__v100-scoreBoard__scoreHolder__score">{match.score.halfTimeScore.split(":")[1]}</div>
      </div>
    )}
  </div>
  <div className="kick__v100-gameCell__team kick__v100-gameCell__team_right">
    <div className="kick__v100-gameCell__team__name">{match.awayTeam.name}</div>
    <div className="kick__v100-gameCell__team__shortname">{match.awayTeam.name}</div>
    <div className="kick__v100-gameCell__team__info"></div>
    <div className="kick__v100-gameCell__team__logo">
      {match.awayTeam.icon && (
        <Image src={match.awayTeam.icon} alt="Logo" width="36" height="36" className="kick__flag-shadow" />
      )}
    </div>
  </div>
  {/* {match.id && <Link href={`/article/${match.id}`}><div>zum Liveticker</div></Link>} */}
</div>)
}

export default function TickerEncounter(data: {sportsMatches: SportsMatches}) {
  const sportsmatches = data.sportsMatches;
  
  return (
    <React.Fragment>
      <div className="">
        <div className="kick__ticker ticker__row kick__card kick__ressort-headline kick__site-padding kick__matches">
          <div className="ticker__header">
            <div className="ticker__header__wrapper">
              <h2 className="modul__teaser__headline">{sportsmatches.headline}</h2>
            </div>
          </div>
          <div className="kick__modul__item">
            <div className="kick__v100-scoreboardInfo">
            </div>
            <div id="fixtures">
              {sportsmatches.matches.map((match, index) =>
                <React.Fragment key={`match-${index}-${match.id}`}>
                  {match.id && 
                    <Link href={match.id} className="match-link">
                        {renderMatch(match)}
                        <div className="live_hint">zum Liveticker</div>
                    </Link>
                  }
                  {!match.id && <>{renderMatch(match)}</>}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
